import { motion } from "framer-motion";
import { Handshake, TrendingUp, Users, Shield, ArrowRight } from "lucide-react";
import { LeadForm } from "../components/sections/LeadForm";
import { SEO } from "../components/common/SEO";
import { SEO_DATA } from "../data/seoData";

export default function PartnerPage() {
  return (
    <div>
      <SEO 
        title={SEO_DATA.partner.title}
        description={SEO_DATA.partner.description}
        keywords={SEO_DATA.partner.keywords}
        canonical="https://switchyourvendor.com/partner"
      />
      <section className="pt-20 pb-14 relative" style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #ffffff 50%, #fff5f5 100%)" }}>
        <div className="max-w-7xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl">
            <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">Partner Program</span>
            <h1 className="font-heading text-4xl sm:text-5xl font-black mt-3 mb-4 tracking-tight">
              Partner With<br /><span className="bg-gradient-to-r from-red-600 to-rose-500 bg-clip-text text-transparent">SwitchYourVendor</span>
            </h1>
            <p className="text-slate-500 text-base md:text-lg leading-relaxed font-body">
              Join our growing network of verified vendors and service providers. Get access to qualified business leads and grow your revenue with zero marketing spend.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-10">
            <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">Benefits</span>
            <h2 className="font-heading text-3xl font-black mt-3 tracking-tight">Why Partner With Us</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { icon: Users, title: "Qualified Leads", desc: "Get pre-qualified business leads actively looking for your services — no cold calling needed.", color: "#dc2626" },
              { icon: TrendingUp, title: "Grow Revenue", desc: "Our partners see an average 40% revenue growth within the first 6 months of joining.", color: "#10b981" },
              { icon: Handshake, title: "Zero Commission Initially", desc: "Start with zero commission fees. We invest in your success before we earn.", color: "#6366f1" },
              { icon: Shield, title: "Brand Visibility", desc: "Get featured on our platform and marketing campaigns reaching thousands of businesses.", color: "#f59e0b" },
            ].map(({ icon: Icon, title, desc, color }, i) => (
              <motion.div key={title} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} className="bg-slate-50 rounded-2xl p-7 border border-slate-100 hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ background: `${color}10` }}>
                  <Icon size={22} style={{ color }} />
                </div>
                <h3 className="text-base font-extrabold text-slate-900 mb-2 font-body">{title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed font-body">{desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="py-14 bg-slate-50">
        <div className="max-w-2xl mx-auto px-6">
          <div className="text-center mb-10">
            <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">Apply Now</span>
            <h2 className="font-heading text-3xl font-black mt-3 mb-2 tracking-tight">Become a Partner</h2>
            <p className="text-slate-500 text-sm font-body">Fill out the form and our partnerships team will reach out within 48 hours.</p>
          </div>
          <LeadForm />
        </div>
      </section>
    </div>
  );
}
